import { render, staticRenderFns } from "./ChatClusterMember.vue?vue&type=template&id=3e90beb5&"
import script from "./ChatClusterMember.vue?vue&type=script&lang=js&"
export * from "./ChatClusterMember.vue?vue&type=script&lang=js&"
import style0 from "./ChatClusterMember.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports